/*
 * Подпись под именем человека: все его должности сразу, а не одна основная
 * (решение Ильи 15.09.2026). Человек часто занимает две — «CEO & партнёр», — и
 * показывать только первую значит врать о его роли в компании.
 *
 * Порядок: основная впереди, дальше как пришли с сервера. Отменённые и
 * закончившиеся замещения не показываются: подпись говорит, кто человек
 * сегодня.
 */

/**
 * Должность настолько, насколько её знает вызывающий экран: в профиле приходит
 * полная запись со сроками, в карточке человека — только название и признак
 * основной.
 */
type Position = { name: string; isPrimary: boolean; active?: boolean };

/** Должности одной строкой: «CEO & партнёр», «CEO, ГИП & партнёр». */
export function positionsLabel(positions: Position[] | undefined): string {
  const live = (positions ?? []).filter((p) => p.active !== false);
  const ordered = [...live.filter((p) => p.isPrimary), ...live.filter((p) => !p.isPrimary)];
  const names = ordered.map((p) => p.name).filter(Boolean);
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  // Амперсанд вместо союза — выбор Ильи 16.09.2026: подпись короче и не
  // читается как продолжение фразы.
  return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
}
